import formatDate from '@/services/Formatter/DateFormatter';
import advancedSearch from '@/translations/fr/components/globals/advancedSearch';
import { AdvancedSearchConfiguration } from '@/types';
import { ChipItem } from '@cnamts/vue-dot/src/elements/ChipList/types';
import { PeriodValue } from '@cnamts/vue-dot/src/patterns/PeriodField/types';

const advancedSearchService = {
	formatChip(advancedSearchConfiguration: AdvancedSearchConfiguration): any {
		if (undefined === advancedSearchConfiguration.filters) {
			return;
		}
		advancedSearchConfiguration.filters.forEach((filter: any) => {
			if ('remunerationPeriod' === filter.type)  {
				filter.formatChip = (value: []) => {

					return this.customRemunerationPeriodChip(filter.choices, value);
				};
			}

			if (filter.hasOwnProperty('choices') && 'remunerationPeriod' !== filter.type)  {
				filter.formatChip = (value: []) => {
					return this.customFormatChip(filter.choices, value);
				};
			}

			if ('dateRange' === filter.type) {
				filter.formatChip = (value: PeriodValue) => {
					return this.customDateRangeChip(value);
				};
			}

			if ('amountInput' === filter.type) {
				filter.formatChip = (value: string) => {
					return this.customAmountChip(value);
				};
			}
		});
	},

	customRemunerationPeriodChip(choices: [], value: []): ChipItem[] {
		const chips: ChipItem[] = [];
		choices.forEach((choice: any): void => {
			if (JSON.stringify(choice.value) === JSON.stringify(value)) {
				chips.push({
					text: choice.text,
					value: choice.value
				});
			}
		});

		return chips;
	},

	customFormatChip(choices: [], selectedValues: []): ChipItem[] {
		const chips: ChipItem[] = [];

		choices.forEach((choice: any): void => {
			if (undefined !== selectedValues.find((element): boolean => element === choice.value && !chips.some(obj => obj.value === choice.value))) {
				chips.push({
					text: choice.text.substr(0, 40),
					value: choice.value
				});
			}
		});

		return chips;
	},

	customDateRangeChip(value: PeriodValue): ChipItem[] {
		const chips: ChipItem[] = [];

		if (null === value.from && null === value.to) {
			return chips;
		}

		let text = '';

		if (value.from !== null && value.to !== null) {
			text = advancedSearch.chip.dateRange.from + ' ' + formatDate(value.from, 'DD/MM/YYYY') + ' ' + advancedSearch.chip.dateRange.to + ' '  + formatDate(value.to, 'DD/MM/YYYY');
		} else {
			text = value.from !== null ? advancedSearch.chip.dateRange.onlyFrom + ' ' + formatDate(value.from, 'DD/MM/YYYY') : advancedSearch.chip.dateRange.onlyTo + ' ' + formatDate(value.to, 'DD/MM/YYYY');
		}

		chips.push({
			text: text,
			value: value
		});

		return chips;
	},

	customAmountChip(value: string): ChipItem[] {
		const chips: ChipItem[] = [];

		if (null === value || '' === value) {
			return chips;
		}

		chips.push({
			text: value + ' €',
			value: value.replace(',', '.')
		});

		return chips;
	}
};

export default advancedSearchService;
